import { defineMessages } from 'react-intl';

export default defineMessages({
  matomoVisits: 'Visits',
  matomoActions: 'Actions',
  segment: 'Segment',
  all: 'All visits',
  visits: 'Visits',
  uniqueVisitors: 'Unique visitors',
  pageViews: 'Page views',
  surveyResponses: 'Survey responses',
  questionResponses: 'Question responses',
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
  YEAR: 'Year',
});
